import { render, staticRenderFns } from "./mProductCard.vue?vue&type=template&id=463e1d82"
import script from "./mProductCard.vue?vue&type=script&lang=ts"
export * from "./mProductCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports